var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXby(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32941)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#56F4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.375 5.0715C3.375 5.06306 3.49313 5.0625 5.01638 5.06362L6.65831 5.06531L7.59206 6.63638L8.54156 8.23444L8.55731 8.26087L8.70581 8.00775C8.78681 7.86825 8.85319 7.75181 8.85206 7.74844C8.85094 7.74506 8.49375 7.14206 8.05894 6.40969C7.62413 5.67731 7.26806 5.07488 7.26806 5.07094C7.26806 5.06363 7.515 5.0625 8.99663 5.0625C9.95625 5.0625 10.7246 5.06475 10.7246 5.06813C10.7246 5.07938 7.05994 11.3102 7.0515 11.3119C7.04531 11.313 6.50925 10.4074 5.20875 8.19731C4.20019 6.48338 3.375 5.07712 3.375 5.0715ZM11.3287 5.06644C11.3287 5.06419 12.0712 5.0625 12.9774 5.0625H14.625L14.6228 5.07488C14.6211 5.08219 13.7998 6.48169 12.798 8.18494C11.5836 10.2476 10.9721 11.2821 10.9643 11.2832C10.9569 11.2843 10.7848 10.998 10.2077 10.0266C9.79594 9.33469 9.45787 8.76656 9.45562 8.76544C9.45112 8.76263 9.15581 9.26381 9.15806 9.27056C9.15863 9.27338 9.49781 9.84431 9.91069 10.5396C10.1644 10.9617 10.4138 11.3864 10.6588 11.8136C10.6537 11.8333 9.00731 14.6233 9.00056 14.625C8.98987 14.6272 7.353 11.8463 7.35637 11.8322C7.35919 11.826 11.2686 5.16656 11.3287 5.06644Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32941"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXby);
export default __webpack_public_path__ + "static/media/xby.a30ef81d5132850387bbd25ceef3de63.svg";
export { ForwardRef as ReactComponent };